// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g0kFCtom {
  min-height: 100vh;
  min-height: 100dvh;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
          flex-direction: column;
  position: relative;
  width: 100%;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: auto;
}
@media (max-width: 767px) {
  .vXUJ2xqq {
    min-height: 100vh;
    min-height: 100dvh;
    height: auto;
    max-height: none;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
@media (min-width: 768px) {
  .vXUJ2xqq {
    min-height: 100vh;
    min-height: 100dvh;
    height: auto;
    max-height: none;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
._SAaOz3F {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
          flex: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
          flex-direction: column;
  min-height: 0;
  padding-bottom: 0;
}
@media (max-width: 767px) {
  .vXUJ2xqq ._SAaOz3F {
    overflow-x: hidden;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .vXUJ2xqq ._SAaOz3F {
    overflow-x: hidden;
    overflow-y: auto;
    padding-top: 5rem;
    box-sizing: border-box;
  }
}
@media (max-width: 767px) {
  ._SAaOz3F {
    padding-bottom: 0;
  }
}
@media (min-width: 1024px) {
  ._SAaOz3F {
    padding-bottom: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/Layout.module.less","webpack://./src/styles/mixins.less"],"names":[],"mappings":"AAGA;EACE,iBAAA;EACA,kBAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;EAAA,8BAAA;UAAA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAFF;ACNE;EAAA;IDcE,iBAAA;IACA,kBAAA;IACA,YAAA;IACA,gBAAA;IACA,kBAAA;IACA,gBAAA;EAJF;AACF;ACQE;EAAA;IDDE,iBAAA;IACA,kBAAA;IACA,YAAA;IACA,gBAAA;IACA,kBAAA;IACA,gBAAA;EAHF;AACF;AAMA;EACE,mBAAA;EAAA,eAAA;UAAA,OAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;EAAA,8BAAA;UAAA,sBAAA;EACA,aAAA;EAgBA,iBAAA;AAnBF;ACjCE;EAAA;IDwCI,kBAAA;IACA,mBAAA;EAHJ;AACF;ACfE;EAAA;IDqBI,kBAAA;IACA,gBAAA;IAEA,iBAAA;IACA,sBAAA;EAHJ;AACF;AC/CE;EAAA;IDuDE,iBAAA;EAJF;AACF;AClCE;EAAA;IDyCE,iBAAA;EAHF;AACF","sourcesContent":["@import '@/styles/variables.less';\n@import '@/styles/mixins.less';\n\n.layout {\n  min-height: 100vh;\n  min-height: 100dvh;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: 100%;\n  min-width: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n// 首页：默认一屏展示；浏览器缩放导致内容超高时由 layout 纵向滚动承载\n.layoutHome {\n  .mobile({\n    min-height: 100vh;\n    min-height: 100dvh;\n    height: auto;\n    max-height: none;\n    overflow-x: hidden;\n    overflow-y: auto;\n  });\n\n  .tablet-up({\n    min-height: 100vh;\n    min-height: 100dvh;\n    height: auto;\n    max-height: none;\n    overflow-x: hidden;\n    overflow-y: auto;\n  });\n}\n\n.main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n\n  .layoutHome & {\n    .mobile({\n      overflow-x: hidden;\n      overflow-y: visible;\n    });\n\n    .tablet-up({\n      overflow-x: hidden;\n      overflow-y: auto;\n      // Header 为 fixed，需在 main 内预留顶栏高度，banner 才能在可视区垂直居中\n      padding-top: @layout-header-height-desktop;\n      box-sizing: border-box;\n    });\n  }\n  padding-bottom: 0; // 移除底部padding，让内容自然流动\n\n  .mobile({\n    padding-bottom: 0;\n  });\n\n  .desktop({\n    padding-bottom: 0;\n  });\n}\n\n","@import './variables.less';\n\n// 响应式 Mixins\n.mobile(@rules) {\n  @media (max-width: 767px) {\n    @rules();\n  }\n}\n\n.mobileNarrow(@rules) {\n  @media (max-width: 413px) {\n    @rules();\n  }\n}\n\n.tablet(@rules) {\n  @media (min-width: 768px) and (max-width: 1023px) {\n    @rules();\n  }\n}\n\n.desktop(@rules) {\n  @media (min-width: 1024px) {\n    @rules();\n  }\n}\n\n.tablet-up(@rules) {\n  @media (min-width: 768px) {\n    @rules();\n  }\n}\n\n// 紧凑 PC（1024~1728 宽）：首页 banner 缩小与垂直微调\n.homeCompactPc(@rules) {\n  @media (min-width: 1024px) and (max-width: 1728px) {\n    @rules();\n  }\n}\n\n.homeCompactPcShort(@rules) {\n  @media (min-width: 1024px) and (max-width: 1728px) and (max-height: 1000px) {\n    @rules();\n  }\n}\n\n// 宽屏 PC（>1728 宽）：首页 banner 放大\n.homeWidePc(@rules) {\n  @media (min-width: 1729px) {\n    @rules();\n  }\n}\n\n// 浏览器放大/缩小时：横向裁切装饰溢出，纵向允许滚动避免内容显示不全\n.zoomScrollablePage() {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n// Flexbox Mixins\n.flex-center() {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.flex-between() {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.flex-start() {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n// 文本省略\n.text-ellipsis() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-ellipsis-multi(@lines: 2) {\n  display: -webkit-box;\n  -webkit-line-clamp: @lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n// 清除浮动\n.clearfix() {\n  &::after {\n    content: '';\n    display: table;\n    clear: both;\n  }\n}\n\n// 按钮重置\n.button-reset() {\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  outline: none;\n  font-family: inherit;\n}\n\n// 触摸友好\n.touch-friendly() {\n  min-height: 2.75rem; // 44px\n  min-width: 2.75rem; // 44px\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `g0kFCtom`,
	"layoutHome": `vXUJ2xqq`,
	"main": `_SAaOz3F`
};
export default ___CSS_LOADER_EXPORT___;
